<header class="page-header">
  <div>
    <h2 class="page-title">{{ isAdmin ? 'Todos los Reportes' : 'Mis Reportes' }}</h2>
    <p class="page-subtitle">{{ isAdmin ? 'Historial de exportaciones de todos los usuarios.' : 'Historial de exportaciones generadas por ti.' }}</p>
  </div>
</header>

<div class="clean-card table-container">
  <div class="table-toolbar">
    <div class="polling-indicator" *ngIf="hasActiveJobs()">
      <span class="pulse-dot"></span>
      <span>Actualizando automáticamente...</span>
    </div>
    <div *ngIf="!hasActiveJobs()"></div>

    <button class="btn-secondary" (click)="onRefresh()" [disabled]="isLoading">
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading && jobs.length === 0" class="feedback-state">
    <mat-icon class="feedback-icon spinning">sync</mat-icon>
    <p>Cargando reportes...</p>
  </div>

  <!-- Empty -->
  <div *ngIf="!isLoading && jobs.length === 0" class="feedback-state">
    <mat-icon class="feedback-icon">inbox</mat-icon>
    <p>No hay reportes generados aún.</p>
  </div>

  <!-- Table -->
  <table *ngIf="jobs.length > 0" class="clean-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>TIPO</th>
        <th>ESTADO</th>
        <th>FECHA</th>
        <th *ngIf="isAdmin">SOLICITADO POR</th>
        <th>ACCIONES</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let job of jobs" class="table-row">
        <td class="text-light font-mono" title="{{ job.jobUuid }}">{{ job.jobUuid | slice:0:8 }}…</td>
        <td class="font-medium">{{ job.jobType }}</td>
        <td>
          <span class="badge" [ngClass]="getStatusClass(job.jobStatus)">
            {{ getStatusLabel(job.jobStatus) }}
          </span>
        </td>
        <td class="text-light">{{ job.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
        <td *ngIf="isAdmin" class="text-light">{{ job.requestedBy }}</td>
        <td>
          <div class="actions">
            <button
              mat-icon-button
              class="icon-btn download"
              [disabled]="job.jobStatus !== 'COMPLETED' || downloadingJobUuid === job.jobUuid"
              (click)="downloadJob(job)"
              title="Descargar"
            >
              <mat-icon>{{ downloadingJobUuid === job.jobUuid ? 'hourglass_empty' : 'download' }}</mat-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="table-footer" *ngIf="jobs.length > 0">
    <span>{{ jobs.length }} reporte{{ jobs.length !== 1 ? 's' : '' }}</span>
  </div>
</div>
